<template>
    <!-- page content -->
    <div class="right_col" role="main">
        <div class="">
            <div class="page-title">
                <div class="title_left">
                    <h3>{{pinWordReplacementWith}}</h3>
                </div>
                <div class="title_right">
                    <div class="col-md-5 col-sm-5   form-group pull-right top_search">
                        <router-link :to="{path: 'addsinglepin'}"
                                     class="ml-4 btn btn-info btn-sm text-white pull-right">
                            <i class="fa fa-plus-square"></i> Add New
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-sm-12">
                <div class="alert alert-info" v-if="alert_message">
                    {{alert_message}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <section class="content">
                        <form v-on:submit.prevent="dopagination(0)">
                            <div class="row">
                                <div class="col-xs-6 col-sm-2 form-group">
                                    <input :placeholder="pinWordReplacementWith" type="text" name="login" v-model="login" id="login"
                                           class="form-control input-sm" value="">
                                </div>
                                <div class="col-xs-6 col-sm-2 form-group">
                                    <select title="" name="idLots" id="lots_id" class="form-control input-sm select2"
                                            v-model="lots_id" v-select="lots_id" @change="dopagination(0)">
                                        <option value="0">Select Subscription Batch</option>
                                        <option v-for="(data) in batchArr" :key="data.id" value="" :value="data.lot_id">
                                            {{data.description}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-xs-6 col-sm-2 form-group">
                                    <input placeholder="Range Of Batch Subscription: 1-9" disabled type="text"
                                           name="batch_pin_serial" id="batch_pin_serial" v-model="batch_pin_serial"
                                           class="form-control input-sm" value="">
                                </div>
                                <div class="col-xs-6 col-sm-2 form-group">
                                    <select title="" name="id_reseller" id="id_reseller" v-model="id_reseller"
                                            v-select="id_reseller" class="form-control input-sm select2"
                                            @change="dopagination(0)">
                                        <option value="">All Agent</option>
                                        <option v-for="(data, index) in reseller_list" :key="data.id" :value="index">
                                            {{data}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-xs-6 col-sm-2 form-group">
                                    <select title="" name="status" id="status" v-model="status" v-select="status"
                                            class="form-control input-sm select2" @change="dopagination(0)">
                                        <option value="">All</option>
                                        <option value="1">Active</option>
                                        <option value="2">Inactive</option>
                                        <option value="3">Expired</option>
                                        <option value="4">Subscribed</option>
                                        <option value="5">Not subscribed (Active)</option>
                                    </select>
                                </div>

<!--                                <div class="col-xs-6 col-sm-2 form-group" v-if="showDropdown">-->
<!--                                    <select title="" name="is_online" id="is_online" v-model="is_online"-->
<!--                                            v-select="is_online" class="form-control input-sm select2"-->
<!--                                            @change="dopagination(0)">-->
<!--                                        <option value="" selected="">All (Offline + Online)</option>-->
<!--                                        <option value="2">Offline</option>-->
<!--                                        <option value="1">Online</option>-->
<!--                                    </select>-->
<!--                                </div>-->

                                <div class="col-xs-6 col-sm-2 form-group">
                                    <select title="" name="limit" id="limit" v-model="display_limit"
                                            v-select="display_limit" class="form-control input-sm select2"
                                            @change="dopagination(0)">
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="75">75</option>
                                        <option value="100">100</option>
                                        <option value="500">500</option>
                                        <option value="1000">1000</option>
                                    </select>
                                </div>
                                <div class="col-xs-6 col-sm-12 form-group pull-right btnRight">
                                    <button type="submit" class="btn btn-sm btn-info pull-right">
                                        <i class="fa fa-search"></i> Search
                                    </button>
                                </div>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 ">
                    <div class="x_panel">
                        <div class="x_title">
                            <h2>
                                Total : {{totalData}}
                                <span v-if="dispplayFrom">
                           Showing {{dispplayFrom}} to {{dispplayTo}}
                        </span>
                                <span class="pull-right noOfData">
                           {{totalData}}
                        </span>
                            </h2>
                            <div class="clearfix"></div>
                        </div>
                        <div class="x_content table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th class="tdCenter tdSN">SN</th>
                                    <th class="tdCenter">{{pinWordReplacementWith}}</th>
                                    <th class="tdCenter" v-if="userData.reseller4.is_single_pin_login !=1">Password</th>
                                    <th class="tdCenter">{{pinWordReplacementWith}} Batch Name</th>
                                    <th class="tdCenter">B.{{pinWordReplacementWith}} SL</th>
                                    <th class="tdCenter">Activate At</th>
                                    <th class="tdCenter">First login after activation</th>
                                    <th class="tdCenter">Expire Date</th>
                                    <th class="tdCenter">No of days</th>
                                    <th class="tdCenter">Validity Plan</th>
                                    <th class="tdCenter">Status</th>
                                    <th class="tdCenter" style="width: 60px">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(data, index) in pinListArr" :key="data.id">
                                    <td class="tdCenter tdSN">
                                        {{parseInt(sl) + index}}
                                    </td>
                                    <td class="tdCenter">
                                        <a href="#" title="View Device" class="colorbox" @click="loadDeviceList(data.id)">
                                            {{com_removeHostedPinPrefix(data.username, userData.reseller4.hosted_pin_prefix, userData.reseller4.reseller_panel_type)}}
                                        </a>
                                    </td>
                                    <td class="tdCenter" v-if="userData.reseller4.is_single_pin_login !=1" @dblclick="contentEdit(data.id);" @blur="updatePassword(data.id)" :original-value="data.value" :username="data.username" :id="'passWord-'+data.id">

                                       <span :id="'passwordShowDiv_'+data.id">
                                          <button type="button" @click="showPinPass(data.id)" class=" btn btn-sm btn-submit bg-yellow" style="border-radius: 2px"> <i class="fa fa-eye" ></i></button>
                                       </span>

                                    </td>
                                    <td class="tdCenter">
                                        {{data.lot_name}}
                                    </td>
                                    <td class="tdCenter info">
                                        {{data.batch_pin_serial}}
                                    </td>
                                    <td class="tdCenter info">
                                        {{data.activate_at}}
                                    </td>
                                    <td class="tdCenter info">
                                        {{data.after_activate_first_login_at}}
                                    </td>
                                    <td class="tdCenter info">
                                        {{data.validity_date}}
                                    </td>
                                    <td class="tdCenter info">
                                        {{data.no_of_days}}
                                    </td>
                                    <td class="tdCenter">
                                        {{data.description}}
                                    </td>
                                    <td class="tdCenter" v-if="data.status==1">
                                        <span class='label label-success'>Active</span>
                                    </td>
                                    <td class="tdCenter" v-else-if="data.status==2">
                                        <span class='label label-danger'>Inactive</span>
                                    </td>
                                    <td class="tdCenter" v-else>
                                        <span class='label label-warning'>Expire</span>
                                    </td>
                                    <td class="tdCenter">
                                        <a v-if="data.allowresetpin" title='Return Balance and Deactivate PIN' :class="data.has_return_request !=1 ? 'btn btn-sm text-danger':'btn btn-sm text-yellow'" @click="returnPin(data.id, data.has_return_request)" style="padding: 2px 5px;">
                                            <i class="fa fa-reply" aria-hidden="true"></i>
                                        </a>

                                        <a v-if="(data.status == 1 && data.udid && userData.reseller.pin_reset == 1 && userData.reseller4_id != 98 && userData.reseller4_id != 304 )" title='Reset UDID' class='btn btn-sm text-warning' @click="resetPin(data.id)" style="padding: 2px 5px;">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                </tr>
                                <tr v-if="pinListArr.length==0">
                                    <td colspan="17" class="tdCenter" style="padding: 30px 0;"><b>No Records
                                        Found</b></td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="pagination" v-if="last_page > 1">
                                <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                                    « Previous
                                </a>
                                <span v-else class="disabled">« Previous</span>
                                <span v-if="last_page > max_display_pagination">
                              <span v-for="index in last_page">
                                 <span v-if="index==1||index==2">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                    <span v-if="(index==2) && firstDotted">..</span>
                                 </span>
                                 <span v-if="randomPageNumber.includes(index)">
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                                 <span v-if="index==last_page||index==last_page-1">
                                    <span v-if="(index==last_page-1) && lastDotted">
                                       ..
                                    </span>
                                    <span class="current" v-if="index==current_page">
                                       {{index}}
                                    </span>
                                    <span v-else>
                                       <a href="#" @click="dopagination(index)">
                                          {{index}}
                                       </a>
                                    </span>
                                 </span>
                              </span>
                           </span>
                                <span v-else>
                              <span v-for="index in last_page">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">{{index}}</a>
                                 </span>
                              </span>
                           </span>
                                <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                                    Next »
                                </a>
                                <span v-else class="disabled">Next »</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /page content -->
</template>
<script>
    import axios from 'axios'

    export default {
        name: "PinList",
        data() {
            return {
                pinWordReplacementWith: process.env.VUE_APP_PIN_WORD_REPLACEMENT_WITH,
                userData: {},
                pinListArr: [],
                batchArr: {},
                reseller_list: {},
                login: '',
                batch_pin_serial: '',
                id_reseller: '',
                lots_id: 0,
                deviceArr: {},

                alert_message: '',
                dispplayFrom: 0,
                dispplayTo: 0,
                totalData: 0,
                display_limit: 50,
                status: 1,
                sl: 1,
                operation_type: 1,
                is_online: 2,
                showDropdown: false,

                // Pagination Variables
                prev_page_url: false,
                next_page_url: false,
                last_page: 1,
                current_page: null,
                max_display_pagination: 9,
                randomPageNumber: {},
                firstDotted: false,
                lastDotted: false,
                prevPage: '',
                nextPage: '',
            }
        },
        created() {
            this.com_user_type_access([0, 1], true);
            var encryptedData = this.$store.getters.getUser;
            var decodedString = this.com_DecryptString(encryptedData);
            this.userData = JSON.parse(decodedString);
            this.showDropdown = this.com_onlineReportAccess();
            var rootObject = this;
            loader.show();
            axios.get('batches').then(function (response) {
                rootObject.batchArr = response.data.batchData.data;
            })
                .catch(function (error) {
                    rootObject.com_errorHandel(error);
                    let alertmessage = "";
                    for (var prop in error.response.data) {
                        alertmessage += ' ' + error.response.data[prop]
                    }
                    console.log(alertmessage);
                });

            axios.get('get-reseller-dropdown-data').then(function (response) {
                rootObject.reseller_list = response.data.data;
            })
                .catch(function (error) {
                    rootObject.com_errorHandel(error);
                    let alertmessage = "";
                    for (var prop in error.response.data) {
                        alertmessage += ' ' + error.response.data[prop]
                    }
                    console.log(alertmessage);
                });

            loader.hide();
            //this.loadPinList();
        },
        methods: {
            loadPinList() {
                loader.show();
                var rootObject = this;
                axios.get('pins').then(function (response) {
                    rootObject.populatePinListData(response);
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        loader.hide();
                        rootObject.com_errorHandel(error);
                    });
            },

            dopagination(page_no = '') {
                loader.show();
                var rootObject = this;

                let querystr = 'login=' + this.login + '&status=' + this.status + '&paginate=' + this.display_limit + '&batch_id=' + this.lots_id + '&sl_of_batch_pin=' + this.batch_pin_serial + '&id_reseller=' + this.id_reseller + '&is_online=' + this.is_online;

                if (page_no > 0) {
                    querystr += "&page=" + page_no;
                } else {
                    querystr += "&page=1";
                }
                //console.log(querystr);

                axios.get('pins?' + querystr).then(function (response) {
                    rootObject.populatePinListData(response);
                })
                    .catch(function (error) {
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        loader.hide();
                        rootObject.com_errorHandel(error);
                    });
            },

            populatePinListData(response) {
                this.sl = parseInt(response.data.from);

                var current_date_time = this.com_currentDateTime();
                var userData = this.userData;
                for (var prop in response.data.data) {
                    var allowresetpin = false;
                    var showPeriod = this.com_modifyDateTime(3, response.data.data[prop]['after_activate_first_login_at']);
                    if (showPeriod >= current_date_time) {
                        if (response.data.data[prop]['reseller_level'] == userData.user_level) {
                            allowresetpin = true;
                        }
                    }
                    response.data.data[prop]['allowresetpin'] = allowresetpin;
                }
                this.pinListArr = response.data.data;
                //console.log(this.pinListArr);

                this.totalData = response.data.total;
                this.dispplayFrom = response.data.from;
                this.dispplayTo = response.data.to;
                this.display_limit = response.data.per_page;
                this.paginationGenerate(response);
                loader.hide();
            },

            paginationGenerate(response) {
                this.prev_page_url = response.data.prev_page_url;
                this.next_page_url = response.data.next_page_url;
                this.last_page = response.data.last_page;
                this.current_page = response.data.current_page;
                this.randomPageNumber = [];
                this.firstDotted = false;
                this.lastDotted = false;
                this.prevPage = this.current_page - 1;
                this.nextPage = this.current_page + 1;
                let countableOtherPages = this.max_display_pagination - 4;
                if (this.current_page == 1 || this.current_page == 2) {
                    for (let i = 3; i <= (3 + (countableOtherPages - 1)); i++) {
                        this.randomPageNumber.push(i);
                    }
                    this.lastDotted = true;
                } else if (this.current_page == this.last_page || this.current_page == this.last_page - 1) {
                    let endPage = this.last_page - 2;
                    for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
                        this.randomPageNumber.push(i);
                    }
                    this.firstDotted = true;
                } else {
                    let interval = parseInt(countableOtherPages / 2);
                    if (this.current_page <= (interval + 3)) {
                        for (let i = 3; i <= (3 + (countableOtherPages - 1)); i++) {
                            this.randomPageNumber.push(i);
                        }
                        this.lastDotted = true;
                    } else if (this.current_page >= (this.last_page - (interval + 2))) {
                        let endPage = this.last_page - 2;
                        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
                            this.randomPageNumber.push(i);
                        }
                        this.firstDotted = true;
                    } else {
                        for (let i = this.current_page; i <= (this.current_page + interval); i++) {
                            this.randomPageNumber.push(i);
                        }

                        for (let i = (this.current_page - 1); i >= (this.current_page - interval); i--) {
                            this.randomPageNumber.push(i);
                        }
                    }
                }
                //console.log(this.randomPageNumber);
            },

            resetPin(pin_id) {
                //console.log(pin_id);
                var rootObject = this;
                let msg = "Are you sure to reset this udid?";

                $.confirm({
                    title: 'Confirm!',
                    content: msg,
                    buttons: {
                        yes: function () {
                            loader.show();
                            axios.get('reset-udid/' + pin_id).then(function (response) {
                                //console.log(response);
                                if (response.status == 200) {
                                    rootObject.dopagination(0);
                                    rootObject.alert_message = 'UDID Reset successfully';
                                    loader.hide();
                                    setTimeout(function () {
                                        rootObject.alert_message = '';
                                    }, 3000);
                                }

                            })
                                .catch(function (error) {
                                    rootObject.com_errorHandel(error);
                                    let alertmessage = "";
                                    for (var prop in error.response.data) {
                                        alertmessage += ' ' + error.response.data[prop]
                                    }
                                    //console.log(alertmessage);
                                    $.alert(alertmessage);
                                });
                        },
                        no: function () {
                            //return;
                        }
                    }
                });
            },

            returnPin(pin_id, has_return_request) {
                if (has_return_request == 1) {
                    $.alert("You have sent return request to admin. Please, wait till refund. It takes up to 12 hours");
                    return;
                }

                //console.log(pin_id);
                var rootObject = this;
                let msg = "Are you sure want to return this balance and deactivate?";

                $.confirm({
                    title: 'Confirm!',
                    content: msg,
                    buttons: {
                        yes: function () {
                            loader.show();
                            axios.get('return-pin/' + pin_id).then(function (response) {
                                //console.log(response);
                                if (response.status == 200) {
                                    rootObject.dopagination(0);
                                    rootObject.alert_message = 'You have sent return request to admin. Please, wait till refund. It takes up to 12 hours !';
                                    loader.hide();
                                    setTimeout(function () {
                                        rootObject.alert_message = '';
                                    }, 3000);
                                }

                            })
                                .catch(function (error) {
                                    let alertmessage = "";
                                    for (var prop in error.response.data) {
                                        alertmessage += ' ' + error.response.data[prop]
                                    }
                                    //console.log(alertmessage);
                                    $.alert(alertmessage);
                                    loader.hide();
                                    rootObject.com_errorHandel(error);
                                });
                        },
                        no: function () {
                            //return;
                        }
                    }
                });
            },

            checkAll() {
                if ($("#check_all").prop("checked") == true) {
                    $('.user_id').prop('checked', 'checked');
                } else {
                    $('.user_id').prop('checked', false);
                }
            },

            mulOperation(type) {
                var rootObject = this;

                var checked = document.querySelectorAll('input[name="user_id[]"]:checked').length;
                if (checked == 0) {
                    $.alert('Please select at least a PIN');
                    return;
                }

                /*status count message start*/
                var activePins = [];
                var inActivePins = [];
                var active_count = 0;
                var inactive_count = 0;
                $('input[name="user_id[]"]:checked').each(function () {
                    const status = $(this).prev().val();
                    if (status == 1) {
                        active_count += 1;
                        activePins.push($(this).val());
                    } else {
                        inactive_count += 1;
                        inActivePins.push($(this).val());
                    }
                });
                var activate_message = (active_count > 0) ? `${active_count} PIN's is active.` : '';
                var in_activate_message = (inactive_count > 0) ? `${inactive_count} PIN's is Inactive.` : '';
                /*status count message end*/

                var activation_option = this.operation_type;

                if (activation_option == 1) {
                    if (inactive_count < 1) {
                        $.alert("All PIN's are already active.");
                        return;
                    } else {
                        var msg = ` ${activate_message} ${in_activate_message} Are you sure you want to activate ${inactive_count} PIN's?`;
                    }

                    var users = inActivePins;
                }

                if (activation_option == 2) {
                    if (active_count < 1) {
                        $.alert("All PIN's are already Inactive.");
                        return;
                    } else {
                        var msg = `${in_activate_message} ${activate_message} Are you sure you want to deactivate ${active_count} PIN's?`;
                    }

                    var users = activePins;
                }

                //console.log(users);

                $.confirm({
                    title: 'Confirm!',
                    content: msg,
                    buttons: {
                        yes: function () {
                            loader.show();
                            const form = new FormData()
                            form.append('operation_type', activation_option)
                            form.append('users', JSON.stringify(users))
                            var config = {
                                headers: {'Content-Type': 'multipart/form-data'}
                            }
                            axios.post('bulk-pin-operation', form, config).then(function (response) {
                                //console.log(response);
                                if (response.status == 200) {
                                    rootObject.dopagination(0);
                                    rootObject.alert_message = "Pin\'s " + response.data;
                                    rootObject.checkAll();
                                    loader.hide();
                                    setTimeout(function () {
                                        rootObject.alert_message = '';
                                    }, 3000);
                                }
                            })
                                .catch(function (error) {
                                    rootObject.com_errorHandel(error);
                                    let alertmessage = "";
                                    for (var prop in error.response.data) {
                                        alertmessage += ' ' + error.response.data[prop]
                                    }
                                    //console.log(alertmessage);
                                    $.alert(alertmessage);
                                });
                        },
                        no: function () {
                            return;
                        }
                    }
                });

                //console.log(this.operation_type);
            },

            contentEdit(id) {
                var valId = "#passWord-" + id;
                $(valId).prop("contenteditable", true);
            },

            updatePassword(id) {
                var rootObject = this;
                var valId = "#passWord-" + id;
                var username = $(valId).attr('username');
                var originalVal = $(valId).attr('original-value');

                $(valId).css("cursor", "default");
                $(valId).prop("contenteditable", false);

                var id = id;
                var newPassWord = $(valId).html();
                var newPassWord = newPassWord.replace("<br>", "");
                var newPassWord = newPassWord.replace("&nbsp;", "");
                var newPassWord = newPassWord.replace(/ /g, '');

                if (newPassWord == originalVal) return;
                if (newPassWord == username) {
                    $.alert('Pin and password can not be same');
                    $(valId).text(originalVal);
                    return;
                }
                if (newPassWord == '') {
                    $.alert('password can not be empty');
                    $(valId).text(originalVal);
                    return;
                }
                if (newPassWord.length < 4) {
                    $.alert('Min password length is 4');
                    $(valId).text(originalVal);
                    return;
                }

                var firstDigits = ("" + newPassWord).split("")[0];
                if (isNaN(newPassWord)) {
                    $.alert('Please, input only number value as password');
                    $(valId).text(originalVal);
                    return;
                }
                if (firstDigits == '0') {
                    $.alert('Zero (0) is not allowed as first letter of password');
                    $(valId).text(originalVal);
                    return;
                }

                $(valId).text(newPassWord);

                loader.show();
                const form = new FormData()
                form.append('id', id)
                form.append('value', newPassWord)
                form.append('username', username)
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('reset-password', form, config).then(function (response) {
                    //console.log(response);
                    if (response.status == 200) {
                        rootObject.alert_message = response.data;
                        loader.hide();
                        setTimeout(function () {
                            rootObject.alert_message = '';
                        }, 3000);
                    }

                })
                    .catch(function (error) {
                        loader.hide();
                        rootObject.com_errorHandel(error);
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        //console.log(alertmessage);
                        $.alert(alertmessage);
                    });
            },

            loadDeviceList(id) {
                loader.show();
                var rootObject = this;
                axios.get('device-details?id=' + id).then(function (response) {
                    //console.log(response.data.deviceDtls);
                    rootObject.deviceArr = response.data.deviceDtls;
                    setTimeout(function () {
                        $('.colorbox').colorbox({
                            opacity: 0.8,
                            height: '200px',
                            width: '80%',
                            'inline': true,
                            'open': true,
                            href: function () {
                                return "#viewDeviceList";
                            }
                        });
                        loader.hide();
                    }, 500);
                    //rootObject.loadLinkPopup(id, response.data.ratePlans);
                })
                    .catch(function (error) {
                        //console.log(error);
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        console.log(alertmessage);
                        loader.hide();
                        rootObject.com_errorHandel(error);
                    });
            },

            refreshNow() {
                this.login = '';
                this.batch_pin_serial = '';
                this.id_reseller = '';
                this.lots_id = 0;
                this.display_limit = 50;
                this.status = 1;
                this.last_page = 1;
                this.pinListArr = [];
            },

            showPinPass(val) {
                let rootObject = this;
                var id = val;
                $('#passwordShowDiv_' + id).html('<img src="/assets/img/loading_h.gif" alt="Loading"/>');
                const form = new FormData()
                form.append('id', id);
                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                }
                axios.post('show-pin-pass', form, config).then(function (response) {
                    console.log(response);
                    if (response.status == 200) {
                        $('#passwordShowDiv_' + id).html(response.data);
                    }
                })
                    .catch(function (error) {
                        rootObject.com_errorHandel(error);
                        let alertmessage = "";
                        for (var prop in error.response.data) {
                            alertmessage += ' ' + error.response.data[prop]
                        }
                        //console.log(alertmessage);
                        $.alert(alertmessage);
                    });
            }
        },

        mounted: function () {
            var rootObject = this;
            $("#lots_id").on('change', function () {
                $('#batch_pin_serial').val('');
                if (this.value != 0) {
                    $('#batch_pin_serial').attr('disabled', false);
                } else {
                    $('#batch_pin_serial').val('').attr('disabled', true);
                }
            });

            $(".select2").select2();
        }


    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>